/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonDocumentApprovalListItemViewModelPaginatedResponse } from "../types/PersonDocumentApprovalListItemViewModelPaginatedResponse.ts";
import { personDocumentApprovalListItemViewModelSchema } from "./personDocumentApprovalListItemViewModelSchema.ts";

export const personDocumentApprovalListItemViewModelPaginatedResponseSchema =
  z.object({
    data: z
      .array(z.lazy(() => personDocumentApprovalListItemViewModelSchema))
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  }) as unknown as ToZod<PersonDocumentApprovalListItemViewModelPaginatedResponse>;
